(() => {
 'use strict';
 const key = 'ww-saved-products-v1';
 const valid = value => typeof value === 'string' && value.length > 0 && value.length < 240 && !/[/?#\\]/.test(value);
 const read = () => { try { const data = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(data) ? [...new Set(data.filter(valid))].slice(0,60) : []; } catch { return []; } };
 let saved = read();
 const refresh = () => document.querySelectorAll('[data-ww-save]').forEach(button => {
   const active = saved.includes(button.dataset.productHandle);
   button.setAttribute('aria-pressed', String(active));
   const label = button.dataset.saveLabel || button.getAttribute('aria-label') || 'Save product for later';
   button.dataset.saveLabel = label;
   if (button.hasAttribute('data-save-fixed-label')) return; // name already contains the visible text; aria-pressed carries the state
   button.setAttribute('aria-label', active ? label.replace(/^Save /, 'Unsave ').replace(/ for later$/, '') : label);
 });
 const announce = message => {
   let status = document.getElementById('SavedActionStatus');
   if (!status) { status = document.createElement('div'); status.id='SavedActionStatus'; status.className='visually-hidden'; status.setAttribute('role','status'); document.body.append(status); }
   status.textContent = message;
 };
 document.addEventListener('click', event => {
   const button = event.target.closest('[data-ww-save]'); if (!button) return;
   event.preventDefault(); const handle = button.dataset.productHandle; if (!valid(handle)) return;
   saved = read(); const removing = saved.includes(handle);
   const next = removing ? saved.filter(item => item !== handle) : [...saved,handle].slice(-60);
   try { localStorage.setItem(key,JSON.stringify(next)); saved=next; refresh(); announce(removing?'Removed from saved favorites.':'Saved to your favorites in this browser.'); }
   catch { announce('This browser could not save favorites. Please allow local storage or bookmark the product.'); return; }
   if (removing && document.getElementById('SavedProducts')) { button.closest('article')?.remove(); updateCount(); }
 });
 document.addEventListener('ww:products-updated', refresh);
 document.addEventListener('shopify:section:load', refresh);
 window.addEventListener('storage', event => { if(event.key === key) { saved=read(); refresh(); } });
 refresh();
 const container=document.getElementById('SavedProducts');
 const updateCount=()=>{const status=document.getElementById('SavedStatus'); if(status) { const count=container?.querySelectorAll('article').length||0;status.textContent=count?`${count} saved ${count===1?'favorite':'favorites'}`:'Your list is ready for a little inspiration. Tap a heart while you shop to save a favorite.'; }};
 if(!container)return;
 (async()=>{
   let unavailable=0;
   const handles=saved.slice();
   const root=window.Shopify?.routes?.root||'/';
   for(let i=0;i<handles.length;i+=4){
     const batch=handles.slice(i,i+4);
     const results=await Promise.allSettled(batch.map(async handle=>{
       const response=await fetch(`${root}products/${encodeURIComponent(handle)}?section_id=saved-product-card`);
       if(!response.ok)throw new Error('Unavailable');
       const card=new DOMParser().parseFromString(await response.text(),'text/html').querySelector('article.product-card');
       if(!card)throw new Error('Unavailable');
       return card;
     }));
     results.forEach((result,index)=>{
       if(!saved.includes(batch[index]))return;
       if(result.status==='fulfilled')container.append(result.value);
       else unavailable++;
     });
   }
   updateCount();if(unavailable){const status=document.getElementById('SavedStatus');if(status)status.textContent+=' Some saved items could not be loaded. Please try again later.';}refresh();
 })();
})();
